import { FillPaint, SymbolLayout, SymbolPaint } from "mapbox-gl";
import { ColorScale } from "./PaintStore";
import { View } from "../Store";

export default class PaintBase {
  view: View = "gemeente";

  fillPaint(colorScale: ColorScale, property: string): FillPaint | undefined {
    return undefined;
  }

  symbolPaint(colorScale: ColorScale, property: string): SymbolPaint | undefined {
    return undefined;
  }

  symbolLayout(colorScale: ColorScale, property: string): SymbolLayout | undefined {
    return undefined;
  }
}
